/* Shared CSV core helpers — refactored out of AppStatic / TasksPage (behavior unchanged). */

export const CSV_BOM = "\uFEFF";

/** Escape một giá trị thành 1 ô CSV (quote khi cần). */
export function csvEscape(v: unknown): string {
  const s = v == null ? "" : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Parser CSV tối giản, hỗ trợ quote " và "" escape. KHÔNG dùng papaparse. */
export function parseCsv(text: string): string[][] {
  const rows: string[][] = []; let cur: string[] = []; let cell = ""; let q = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (q) {
      if (c === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else q = false; }
      else cell += c;
    } else {
      if (c === '"') q = true;
      else if (c === ",") { cur.push(cell); cell = ""; }
      else if (c === "\n") { cur.push(cell); rows.push(cur); cur = []; cell = ""; }
      else if (c === "\r") { /* skip */ }
      else cell += c;
    }
  }
  if (cell.length > 0 || cur.length > 0) { cur.push(cell); rows.push(cur); }
  return rows.filter((r) => r.length > 0 && r.some((v) => v !== ""));
}
